import {AuthService} from "./AuthService";

export class AiJobService {
    url = `ai/jobs/`;

    createFixSpiderJob(exception_hash, provider = "gemini", base_branch = "master", model_name = null) {
        const payload = {
            domain: "scraper",
            repo: "pricescraper",
            provider: provider,
            operation: "fix-spider",
            base_branch: base_branch,
            input: {
                exception_hash: exception_hash
            }
        };
        if (model_name)
            payload.model_name = model_name;

        return AuthService.apiPost(this.url, payload).then(res => res.data.data);
    }

    createAddWebsiteSpiderJob(undefined_website_id, provider = "gemini", base_branch = "master", model_name = null) {
        const payload = {
            domain: "scraper",
            repo: "pricescraper",
            provider: provider,
            operation: "add-website-spider",
            base_branch: base_branch,
            input: {
                undefined_website_id: undefined_website_id
            }
        };
        if (model_name)
            payload.model_name = model_name;

        return AuthService.apiPost(this.url, payload).then(res => res.data.data);
    }

    getJobsByExceptionHash(exception_hash) {
        return this.listJobs({exception_hash: exception_hash});
    }

    listJobs(filters = {}) {
        return AuthService.apiGet(this.url, {params: filters}).then(res => {
            const data = res.data.data || res.data;
            if (Array.isArray(data))
                return data;
            if (data && Array.isArray(data.results))
                return data.results;
            return [];
        });
    }

    getJob(job_id) {
        return AuthService.apiGet(this.url + job_id + "/").then(res => res.data.data);
    }

    getJobLogs(job_id) {
        return AuthService.apiGet(this.url + job_id + "/logs/").then(res => res.data.data);
    }

    deleteJob(job_id) {
        return AuthService.apiDelete(this.url + job_id + "/").then(res => res.data.data ? res.data.data : res.data);
    }

    approveJob(job_id) {
        return AuthService.apiPost(this.url + job_id + "/approve/", {}).then(res => res.data.data);
    }

    applyCorrection(job_id, review_note) {
        return AuthService.apiPost(this.url + job_id + "/apply-correction/", {
            review_note: review_note
        }).then(res => res.data.data);
    }

    buildFixSpiderPrompt(exception_hash) {
        return AuthService.apiGet(this.url + "build-prompt/", {
            params: {
                type: "fix-spider-prompt",
                exception_hash: exception_hash
            }
        }).then(res => res.data.data);
    }

    // Builds a manual AI prompt for adding on-site search to a site spider,
    // from a site_search request-probe (search url, keyword, sample result links).
    buildSiteSearchPrompt(website, {spider_name, search_url, keyword, sample_result_urls, response_download_url, scenario, fields} = {}) {
        const params = {type: "site-search-prompt", website: website};
        if (spider_name) params.spider_name = spider_name;
        if (search_url) params.search_url = search_url;
        if (keyword) params.keyword = keyword;
        if (response_download_url) params.response_download_url = response_download_url;
        if (sample_result_urls) params.sample_result_urls = Array.isArray(sample_result_urls) ? sample_result_urls.join(',') : sample_result_urls;
        if (scenario) params.scenario = scenario;
        if (fields && fields.length) params.fields = Array.isArray(fields) ? fields.join(',') : fields;
        return AuthService.apiGet(this.url + "build-prompt/", {params: params}).then(res => res.data.data);
    }

    // Builds a manual AI prompt for working on a product-page spider, tailored to
    // a scenario (new_spider, missing_fields, wrong_data, site_changed, js_headless,
    // variants, blocked, structured_base) and optional focused fields.
    buildProductUrlPrompt(website, {product_url, scenario, fields, response_download_url, error_detail} = {}) {
        const params = {type: "product-url-prompt", website: website || "", product_url: product_url || ""};
        if (scenario) params.scenario = scenario;
        if (response_download_url) params.response_download_url = response_download_url;
        if (fields && fields.length) params.fields = Array.isArray(fields) ? fields.join(',') : fields;
        if (error_detail) params.error_detail = typeof error_detail === "string" ? error_detail : JSON.stringify(error_detail);
        return AuthService.apiGet(this.url + "build-prompt/", {params: params}).then(res => res.data.data);
    }

    getOperations() {
        return AuthService.apiGet(this.url + "operations/").then(res => res.data.data);
    }
}
